<template>
    <div class="reportList padding-20 bgc box-shadow">
        <div class="filters">
            <div class="add">
                <el-button  type="primary" @click="handleReturn">返回课程列表</el-button>
                <el-button  type="primary" @click="handleAdd">新增老师</el-button>
            </div>
            <div class="search">
                <el-input v-model="teachName" placeholder="请输入老师名称" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="reportname" label="老师名称" width="150" class-name="title">
                    <template slot-scope="scope">
                        <div class="imageText">
                            <!--<img :src="scope.row.logourl" :alt="scope.row.reportname">-->
                            <img :src="scope.row.logourl?scope.row.logourl:require('@/common/images/user.png')">
                            <div>{{ scope.row.orgname }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="coursecount" label="课程数"  class-name="center"></el-table-column>
                <el-table-column prop="studentcount" label="学生数" class-name="center"></el-table-column>
                <el-table-column prop="joincount" label="参与数"  class-name="center"></el-table-column>
                <el-table-column prop="status" label="状态"  class-name="center">
                    <template slot-scope="scope">
                        <div class="imgStatus">
                            <span v-if="scope.row.status === 0" style="color: #606266">无效</span>
                            <span v-if="scope.row.status === 1" style="color: #67C23A">有效</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="datetime" label="发布时间"  class-name="center" width="160"></el-table-column>
                <el-table-column label="操作" label-class-name="tr" width="260px">
                    <template slot-scope="scope">
                        <div class="tr">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">{{scope.row.status === 0?'详情':'编辑'}}</el-button>
                            <span class="separator">|</span>
                            <el-button @click="handleDel(scope.row)" type="text" size="small">{{scope.row.status === 0?'恢复':'删除'}}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" @getList="searchClick" ref="page"></page>
        </div>
        <!-- start 新建弹窗 -->
        <el-dialog title="新增老师" :visible.sync="dialogFormVisible">
            <el-form :model="cmgtFormData" :rules="rules" ref="cmgtFormData" label-width="100px" class="starmgt-form">
                <el-form-item label="老师名称" prop="assname">
                    <el-input v-model="cmgtFormData.assname" placeholder="请输入老师名称(不超过8个字)" maxlength="8" v-show="cmgtFormData.status===1"></el-input>
                    <el-input v-model="cmgtFormData.assname" :disabled="true" v-show="cmgtFormData.status===0"></el-input>
                </el-form-item>
                <el-form-item label="老师头像" prop="logoatturlid" class="upload-image" required>
                    <div class="upload">
                        <upload class="avatar-uploader" :imgRule="imgRule"  @setImage="setCCoverfile" :uploadType="uploadType" ref="coverfile" v-if="cmgtFormData.status===1&&dialogFormVisible"></upload>
                        <div v-show="cmgtFormData.status===0" class="noModifiy"><img :src="cmgtFormData.logoatturlid" alt=""></div>
                        <div class="position">
                            <p>建议尺寸180*180px，JPG、PNG格式， 图片小于5M。</p>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="老师介绍" prop="desp">
                    <el-input type="textarea" v-model="cmgtFormData.desp" autocomplete="off" placeholder="请输入老师介绍(不超过120个字)" maxlength="120" v-if="cmgtFormData.status===1"></el-input>
                    <el-input type="textarea" v-model="cmgtFormData.desp" autocomplete="off" :disabled="true"  v-show="cmgtFormData.status===0"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" v-show="cmgtFormData.status===1">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureAdd(cmgtFormData)">确 认</el-button>
            </div>
        </el-dialog>
        <!-- end 新建弹窗 -->
    </div>
</template>

<script>
    import {getTeacherList,saveOrUpdateTeacher,updateTeacherStatus} from 'api/curriculumApi'
    import Upload from 'base/upload/upload'
    import {reportMgtCode} from 'api/enumCode'
    import Share from 'base/share/share'
    import Page from 'base/page/page'
    import {promiseUrlToQRCode} from 'common/js/tools'
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'teacherList',
        data() {
            return {
                logourl:'',
                dialogFormVisible: false,
                teachName:'', //老师名字
                form:{},
                cmgtFormData:{
                    assname: '', // 老师名称
                    teacherinnerid:'', //老师id
                    status:1, //状态（有效、无效）
                    logoatturlid: { // 老师头像
                        bucket: '',
                        fname: '',
                        fsize: '',
                        width: '',
                        height: '',
                        key: '',
                        mimetype: '',
                        objecttype: '',
                        furl: ''
                    },
                    desp: '', // 老师介绍
                },
                rules: {
                    assname: [
                        { required: true, message: '请输入老师名称', trigger: 'blur' }
                    ],
                    // logoatturlid: [
                    //     {validator: validateCoverPicture, trigger: 'blur'}
                    // ],
                },
                imgRule: {
                    cls: 'icon_upload',
                    accept: 'image/png,image/jpeg',
                    size: 2,
                    width: '',
                    height: ''
                },
                uploadType: {
                    catecode: '95',
                    datatype: 'IMAGE'
                },
                logo: require('@/common/images/index/logo.png'),
                statusList: reportMgtCode.status,
                total: 0,
                tableData: []
            }
        },
        mounted() {
            this.apiData = {
                usetype: 2,
                page: 1,
                pageSize: 10
            };
            this._getList()
        },
        methods: {
            setCCoverfile(img){
                console.log(img)
                delete img.type;
                this.cmgtFormData.logoatturlid = img
            },
            // 新增老师
            handleAdd() {
                this.$nextTick(()=>{
                    setTimeout(()=>{
                        this.$refs.coverfile.setImage('')
                    },0);
                    this.cmgtFormData.status = 1;
                    this.cmgtFormData.assname = '';
                    this.cmgtFormData.desp = '';
                    this.cmgtFormData.logoatturlid = '';
                    this.cmgtFormData.teacherinnerid = '';
                    this.dialogFormVisible = true;
                })
            },
            // 确认添加老师
            sureAdd(data){
                this.setLoading(true);
                console.log(data.teacherinnerid)
                console.log(data)
                let params;
                if(data.teacherinnerid){
                    // 编辑
                    if(this.logourl == this.cmgtFormData.logoatturlid){ //未更改图
                         params = {
                            teachername: this.cmgtFormData.assname,
                            orgdesp: this.cmgtFormData.desp,
                            teacherinnerid: data.teacherinnerid, //这也是唯一标示了
                        };
                    }else{
                        let logourl = JSON.stringify(this.cmgtFormData.logoatturlid);
                         params = {
                            logourl:logourl,
                             // logourl:JSON.parse(this.cmgtFormData.logoatturlid),
                            teachername: this.cmgtFormData.assname,
                            orgdesp: this.cmgtFormData.desp,
                            teacherinnerid: data.teacherinnerid,
                        };
                    }
                }else{ //新增
                    let logourl = JSON.stringify(this.cmgtFormData.logoatturlid);
                     params = {
                        logourl:logourl,
                        // logourl:JSON.parse(this.cmgtFormData.logoatturlid),
                        teachername: this.cmgtFormData.assname,
                        orgdesp: this.cmgtFormData.desp,
                    };
                    console.log(params)
                }
                saveOrUpdateTeacher({
                    data: params,
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.dialogFormVisible = false;
                        this.$message({type: 'success', message: '操作成功！'});
                        this._getList()
                    },
                    error: data => {
                        console.log('error：', data);
                        this.setLoading(false);
                        this.dialogFormVisible = false;
                        this.$message.error(data.msg)
                    }
                })
            },
            handleQuery() {
                this.$refs.page.handleSizeChange(1)
            },
            handleEdit(row) {
                console.log(row)
                this.$nextTick(()=>{
                    setTimeout(()=>{
                        // 设置图片回填 coverfile
                        console.log(this.$refs.coverfile);
                        this.$refs.coverfile.setImage(this.cmgtFormData.logoatturlid)
                    },0);
                    this.dialogFormVisible = true;
                    this.cmgtFormData.assname=row.orgname;
                    this.cmgtFormData.desp=row.orgdesp;
                    this.cmgtFormData.logoatturlid=row.logourl;
                    this.logourl=row.logourl;
                    this.cmgtFormData.teacherinnerid=row.teacherinnerid;
                    this.cmgtFormData.status=row.status;
                })
            },
            handleReturn(){
                this.$router.push({name: 'CurriculumList'})
            },
            // 删除
            handleDel(row) {
                updateTeacherStatus({
                    data: {
                        teacherinnerid: row.teacherinnerid,
                        status: row.status===0?1:0
                        },
                    success: data => {
                        if (data.code === '000') {
                            if(row.status===1){
                                this.$confirm('是否确认删除?', '提示', {
                                    confirmButtonText: '确认',
                                    cancelButtonText: '取消',
                                }).then(() => {
                                    this.$message({
                                        type: 'success',
                                        message: '删除成功'
                                    });
                                    this._getList()
                                }).catch(() => {});
                            }else{
                                this.$message({
                                    type: 'success',
                                    message: '恢复成功'
                                });
                                this._getList()
                            }
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            },
            // 获取老师列表
            _getList() {
                this.setLoading(true);
                getTeacherList({
                    data: this.apiData,
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.tableData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 搜索
            searchClick() {
                this.setLoading(true);
                let params = {
                    usetype: 2,
                    name: this.teachName,
                };
                getTeacherList({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.setLoading(false);
                        this.tableData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading',
                'setPage'
            ])
        },
        watch: {},
        computed: {
            ...mapGetters([
                'page',
            ])
        },
        components: {
            Page, Share,  Upload
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";
    .reportList{
        .result-list{
            .imageText{
                img{
                    width: 60px;
                    height: 60px;
                    margin-right: 12px;
                }
            }
        }
    }
    .reportList .center {
        text-align: center;
    }
    /*老师详情*/
    .noModifiy img{
        box-sizing: border-box;
        width: 110px;
        height: 110px;
    }
    /*弹窗样式*/
    .avatar-uploader{
        box-sizing: border-box;
        width: 110px;
        height: 110px;
    }
    .avatar {
        width: 100%;
        height: 126px;
        display: block;
    }
    .avatar-uploader .el-upload {
        width: 110px;
        height: 110px;
        border: 1px dashed #d9d9d9;
        border-radius: unset;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .icon_upload:before {
        background-size: 30%;
        background-position: center;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 212px;
        height: 126px;
        text-align: center;
    }
    .position p{
        margin-left: 10px;
        font-size: 14px;
        color: #C0C4CC;
    }
</style>
